import { programData } from './program.model';

export const programInfoJson = [
  ...programData, // Program靜態設定檔
];
